document.addEventListener('DOMContentLoaded', function () {

  const imageSwiper = new Swiper('.rkImageSwiper', {
    loop: true,
    speed: 900,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.rk-swiper-pagination',
      clickable: true
    }
  });

  const contentSwiper = new Swiper('.rkContentSwiper', {
    loop: true,
    speed: 900,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }
  });

  imageSwiper.controller.control = contentSwiper;
  contentSwiper.controller.control = imageSwiper;

  const collectionSwiper = new Swiper('.collectionSwiper', {
    loop: true,
    slidesPerView: 6,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.collection-pagination',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 6,
      },
    },
  });

  const rkProductSwiper = new Swiper('.rkProductSwiper', {
    slidesPerView: 1,
    spaceBetween: 14,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.rk-product-pagination',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2.3,
        spaceBetween: 18
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 22
      }
    }
  });

  const thumbSwiper = new Swiper(".thumbSwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 5
      }
    }
  });

  // MAIN SLIDER
  const productSwiper = new Swiper(".productSwiper", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    thumbs: {
      swiper: thumbSwiper
    }
  });

  const testimonialSwipe = new Swiper(".testimonialSwipe", {
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      clickable:true,
      el:".testimonial-pagination",
    },
  });
});